
/* injects from baggage-loader */

'use strict';

import headerModule from './components/header/header.module';
import footerModule from './components/footer/footer.module';
import projectListItem from './components/projectListItem/projectlistitem.module';
import investmentListItem from './components/investmentListItem/investmentlistitem.module';
import projectComment from './components/projectComment/projectcomment.module';
import documentListItem from './components/documentListItem/documentlistitem.module';
import commentBox from './components/commentBox/commentbox.module';
import accountWidget from './components/account-widget/account-widget.module';
import addBankAccount from './components/add-bank-account/add-bank-account.module';
import addCard from './components/add-card/add-card.module';
import modalComponent from './components/modalComponent/modalcomponent.module';
import projectPledgeRewardComponent from './components/projectPledgeReward/projectpledgereward.module';

export default angular.module('index.components', [
	headerModule.name,
	footerModule.name,
	projectListItem.name,
	investmentListItem.name,
	projectComment.name,
	documentListItem.name,
	commentBox.name,
	accountWidget.name,
	addBankAccount.name,
	addCard.name,
	modalComponent.name,
	projectPledgeRewardComponent.name
]);



// WEBPACK FOOTER //
// ./src/app/index.components.js